import { Injectable } from '@angular/core';

@Injectable()
export class CartFunctionsService {
  constructor() {}

  // Cart page Functions
  // increamentQty(id: any) {

  // }
  // decreamentQty(id: any) {
  //   this.qty = this.cartItems[id].Quantity;
  //   if (this.qty > 1) {
  //     const qtyObj = {
  //       ID: this.cartItems[id].customID,
  //       Quantity: this.qty - 1
  //     };
  //     this.cartItems[id].Quantity = this.qty - 1; // ARRAY me changes
  //     for (let item of this.globalGetCart.Items) {
  //       if (item.customID === this.cartItems[id].customID) {
  //         item.Quantity = this.cartItems[id].Quantity;
  //       }
  //     }
  //     for (let item of this.PlaceOrderNew.CartItems) {
  //       if (item.customID === this.cartItems[id].customID) {
  //         item.Quantity = this.cartItems[id].Quantity;
  //       }
  //     }
  //     this.getCart();
  //   }

  //   this.totalPrice();
  // }
  // totalPrice() {
  //   if (this.cartItems) {
  //     this.price = 0.00;
  //     for (const row of this.cartItems) {
  //       this.price += (row.Quantity * row.Price);
  //     }
  //     this.globalGetCart.TotalAmount = this.price;
  //   }
  // }
}
